import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';

@Component({
  selector: 'app-practitioner-register',
  templateUrl: './practitioner-register.component.html',
  styleUrls: ['./practitioner-register.component.scss']
})
export class PractitionerRegisterComponent implements OnInit {
  authenticateForm: FormGroup;
  isLoading: boolean = false;
  error: string = null;
  loginSubscriber: Subscription;
  practitioner: Practitioner;

  constructor(private authService: AuthService, private practitionerService: PractitionerService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.authenticateForm = new FormGroup({
      'email': new FormControl({value: null, disabled: true}, [Validators.required, Validators.email]),
      'password': new FormControl(null, [Validators.required, Validators.minLength(6)]),
      'confirmPassword': new FormControl(null, [Validators.required, this.confirmPasswordValidator.bind(this)])
    });
    this._loadPractitioner();
  }

  _loadPractitioner() {
    this.isLoading = true;
    this.route.params.subscribe((params: Params) => {
      this.practitionerService.getPractitioner(params['id']).subscribe((practitioner: Practitioner) => {
        this.practitioner = practitioner;
        this.authenticateForm.patchValue({ 'email': practitioner.email });
        this.isLoading = false;
      }, error => {
        this.error = error;
        this.isLoading = false;
      });
    });
  }

  onSubmit(): void {
    if (this.authenticateForm.invalid) { return; }
    const password = this.authenticateForm.value.password;

    this.isLoading = true;
    this.authService.register(this.practitioner, password).then(_ => {
      this.loginSubscriber = this.authService.login(this.practitioner.email, password).subscribe(_ => {
        this.isLoading = false;
        this.error = null;
        this.router.navigate(['/practitioner/' + this.practitioner.id]);
      }, error => {
        this.error = error.message ? error.message : 'We are unable to create your account at this time.';
        this.isLoading = false;
      })
    }).catch(error => {
      this.error = error.message ? error.message : 'We are unable to create your account at this time.';
      this.isLoading = false;
    })
  }

  confirmPasswordValidator(control: FormControl): {[s: string]: boolean } {
    if (!this.authenticateForm) { return null; }
    if (this.authenticateForm.value.password !== control.value) {
      return { 'passwordsDoNotMatch': true };
    }
    return null;
  }
}
